import cookie from "js-cookie";
import { useState, useContext } from "react";
import TagManager from "react-gtm-module";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import login from "../../components/Layout/util/login";
import fetcher from "../dataProvider";
import { setToken, setUserDetail } from "../redux/actions";
import useLocalStorage from "./useLocalStorage";
import { setUserData } from "../redux/slices/user";
import { isEmpty } from "lodash";
import eventBus from "../../util/eventBus";
import { CommonContext } from "../../components/helper/commonContext";
import { useRouter } from "next/router";

const useGoogleLogin = () => {
  const [isGoogleLoginSuccess, setIsGoogleLoginSuccess] = useState(false);

  const dispatch = useDispatch();

  const [, setAccessToken] = useLocalStorage("accessToken", null);
  const [, setRefreshToken] = useLocalStorage("refreshToken", null);
  const commonContext = useContext(CommonContext);
  const router = useRouter();

  const { mutate: loginGoogle } = useMutation(
    (id_token) =>
      fetcher.post(`v1/auth/login-google`, {
        id_token,
      }),
    {
      onSuccess: (res) => {
        dispatch(setUserData(res?.user));
        const accessToken = res.tokens?.access?.token;
        const refreshToken = res.tokens?.refresh?.token;
        if (typeof window !== "undefined") {
          localStorage.setItem("userCreatedTime", res?.user?.createdAt);
        }

        const tagManagerArgs = {
          dataLayer: {
            event: "Googlelogin",
            Status: "success",
            Method: "google",
            userId: res?.user?.id,
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        cookie.set("token", refreshToken, { expires: 2 });
        let ga_cookies = res?.user?.googleAnalyticsId || [];
        if (!ga_cookies.includes(cookie.get("_ga"))) {
          ga_cookies = [...ga_cookies, cookie.get("_ga")];
          updateGACookies(res?.user?.id, ga_cookies);
        }
        setIsGoogleLoginSuccess(true);
        login(
          res.tokens.access.token,
          res.user.name,
          res.user.email,
          res.user.id,
          res.user.role
        );

        setAccessToken(accessToken);
        setRefreshToken(refreshToken);

        dispatch(
          setToken({
            accessToken: accessToken,
            accessToken: refreshToken,
            isLoggedIn: true,
          })
        );

        dispatch(
          setUserDetail({
            ...res.user,
          })
        );

        if (window != "undefined") {
          if (
            isEmpty(res.user?.mobile) &&
            (localStorage.getItem("nftAction") == "BuyNFT" ||
              localStorage.getItem("nftAction") == "SellNFT")
          ) {
            eventBus.dispatch("openCapturePhoneModal", {
              function_name: "capturephone",
            });
          } else {
            commonContext.setMobileUpdated(true);
            if (localStorage.getItem("nftAction") == "openNormalCalculator") {
              commonContext.setCalculator(true);
            } else if (localStorage.getItem("nftAction") == "BuyNFT") {
              if (localStorage?.getItem("is_tradable") == "true") {
                router.push({
                  pathname: "/payment/BuyTradeNft",
                  query: { tier_id: localStorage?.getItem("tierId") },
                });
              } else {
                router.push({
                  pathname: "/payment/BuyNowNft",
                  query: { tier_id: localStorage?.getItem("tierId") },
                });
              }
            }
          }
        }
      },
    }
  );

  const updateGACookies = async (id, GA_Ids) => {
    try {
      const userData = await fetcher.patch(`/v1/user/${id}`, {
        googleAnalyticsId: GA_Ids,
      });
      if (!isEmpty(userData)) {
        dispatch(setUserData(response));
      }
    } catch (error) {
      console.log("Error", error?.response?.data);
    }
  };

  return [isGoogleLoginSuccess, loginGoogle];
};

export default useGoogleLogin;
